const $body = $('body');
const LOCAL_STORAGE_KEY = 'nm_petProfiler_cart_currentPids';
/**
 * Prevent automatic scroll when modal is shown
 */
function preventModalScroll() {
    const $modal = $('#petProfilerAddToCartModal');
    if ($modal.length) {
        const scrollPosition = $(window).scrollTop();
        $modal.on('show.bs.modal', function () {
            $(window).scrollTop(scrollPosition);
        });
        $modal.on('shown.bs.modal', function () {
            $(window).scrollTop(scrollPosition);
        });
    }
}

/**
 * Global modal scroll prevention
 */
function initModalScrollPrevention() {
    $(document).on('show.bs.modal', '.modal', function () {
        const scrollPosition = $(window).scrollTop();
        $(this).data('scroll-position', scrollPosition);
    });
    $(document).on('shown.bs.modal', '.modal', function () {
        const scrollPosition = $(this).data('scroll-position');
        if (scrollPosition !== undefined) {
            $(window).scrollTop(scrollPosition);
        }
    });
}

/**
 * Open the add to cart modal
 *
 * @param {string} productId product id
 * @param {string} addToCartUrl add to cart url
 */
function addToCartModal(productId, addToCartUrl) {
    $.spinner().start();
    $.ajax({
        url: addToCartUrl,
        method: 'GET',
        data: {
            pid: productId
        },
    }).done(response => {
        $body.find('#petProfilerAddToCartModal').remove();
        if (!response.success) {
            $body.append(response.html);
            const $toast = $('#productNotAddedToast');
            $toast.show();
            setTimeout(() => {
                $toast.remove();
            }, 3000);
        }

        if (response.success) {
            $body.append(response.html);
            const $modal = $('#petProfilerAddToCartModal');
            preventModalScroll();
            const scrollPosition = $(window).scrollTop();
            $modal.modal({
                backdrop: 'static',
                keyboard: false,
                show: false
            });
            $modal.on('show.bs.modal', function () {
                $(window).scrollTop(scrollPosition);
                $('body').addClass('modal-open');
            });
            $modal.modal('show');
            $modal.on('shown.bs.modal', function () {
                const $backdrop = $('.modal-backdrop');
                $backdrop.css({
                    'background-color': 'rgba(0, 0, 0, 0.3)',
                    'backdrop-filter': 'blur(4px)',
                    'z-index': '1040'
                });
                // Prevent page scroll when modal opens
                const currentScroll = $(window).scrollTop();
                setTimeout(() => {
                    $(window).scrollTop(currentScroll);
                }, 10);
            });
            // Cleanup on modal hide
            $modal.on('hide.bs.modal', function () {
                $('body').removeClass('modal-open');
            });
        }

    }).always(() => {
        $.spinner().stop();
    });
}

/**
 * Construct the pet profiler URL
 *
 * @returns {string} the pet profiler URL
 */
function constructPetProfilerURL() {
    const baseUrl =$body.find('.js-pet-profiler-endpoint').val();
    const params = new URLSearchParams();
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('cgid')) {
        params.append('cgid', urlParams.get('cgid'));
    }

    let paramIndex = 1;
    const activeLifeStage = $('.js-pet-profiler-life_stage .js-pet-profiler-refinement.active');

    if (activeLifeStage.length > 0) {
        const lifeStageValue = activeLifeStage.text().trim();
        params.append('prefn' + paramIndex, 'life_stage');
        params.append('prefv' + paramIndex, lifeStageValue);
        paramIndex++;
    }

    const activeSpecialty = $('.js-pet-profiler-specialty .js-pet-profiler-refinement.active');

    if (activeSpecialty.length > 0) {
        const specialtyValue = activeSpecialty.text().trim();
        params.append('prefn' + paramIndex, 'specialty');
        params.append('prefv' + paramIndex, specialtyValue);
        paramIndex++;
    }

    const activeAllergies = $('.js-pet-profiler-allergies .js-pet-profiler-refinement.active');
    activeAllergies.each(function () {
        const allergyValue = $(this).text().trim();
        params.append('prefn' + paramIndex, 'allergens');
        params.append('prefv' + paramIndex, allergyValue);
        paramIndex++;
    });

    const finalUrl = baseUrl + '?' + params.toString();
    return finalUrl;
}

/**
 * Update the mini cart
 *
 * @param {array} currentPids current products in the cart
 * @param {string} petProfilerMiniCartUrl the pet profiler mini cart url
 */
function petProfilerMiniCart(currentPids, petProfilerMiniCartUrl) {
    const $body = $('body');
    $.spinner().start();
    $.ajax({
        url: petProfilerMiniCartUrl,
        method: 'GET',
        data: {
            currentPids: JSON.stringify(currentPids)
        }
    }).done(function (data) {
        $('.js-pet-profiler-minicart__content').html(data);
        $('.js-pet-profiler-minicart').removeClass('d-none');
        $('.js-pet-profiler-search-results-content').removeClass('col-md-12').addClass('col-md-9').addClass('active-minicart');
        $body.find('.js-pet-profiler-dog-weight-input').trigger('focusout');
        $body.find('.js-pet-profiler-mobile-sticky').removeClass('d-none');
    }).always(function () {
        $.spinner().stop();
    });
}

function removeFromCart(pid, $removeButton) {
    $.spinner().start();
    let currentPids = [];
    try {
        currentPids = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY));
    } catch (e) {
        return;
    }
    const newPids = currentPids.filter(productObj => productObj.pid !== pid);
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(newPids));
    $removeButton.closest('.js-pet-profiler-product-container').remove();
    $.spinner().stop();
}

module.exports = {
    addToCartModal: addToCartModal,
    constructPetProfilerURL: constructPetProfilerURL,
    petProfilerMiniCart: petProfilerMiniCart,
    removeFromCart: removeFromCart,
    initModalScrollPrevention: initModalScrollPrevention,
    LOCAL_STORAGE_KEY: LOCAL_STORAGE_KEY,
};
